import { jsx as l } from "react/jsx-runtime";
import { SvgIcon as a } from "../SvgIcon.js";
const c = (o) => /* @__PURE__ */ l(a, { ...o, children: /* @__PURE__ */ l("path", { d: "M3.542 2.5A1.05 1.05 0 0 0 2.5 3.542v1.287c0 .957.44 1.862 1.191 2.455l.003.001 4.223 3.295v6.295a.625.625 0 0 0 .988.509L11.82 15.3a.625.625 0 0 0 .262-.508V10.58l4.223-3.295.003-.001A3.127 3.127 0 0 0 17.5 4.829V3.542A1.05 1.05 0 0 0 16.458 2.5H3.542Zm.208 1.25h12.5v1.08c0 .574-.263 1.115-.714 1.471l-4.462 3.48a.625.625 0 0 0-.24.494v4.195l-1.667 1.19v-5.385a.626.626 0 0 0-.241-.493l-4.461-3.48a1.873 1.873 0 0 1-.715-1.473V3.75Z" }) });
export {
  c as Funnel
};
//# sourceMappingURL=Funnel.js.map
